export default "__VITE_ASSET__DwmpWrBu__"